const ProviderCommentIcon = () => (
  <svg
    className="profile-comment-add-icon"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M2 3h28v21h-6v7l-7-7H2Z" />
    <path d="M16 8v11M10.5 13.5h11" />
  </svg>
);

export default ProviderCommentIcon;
